import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { DetailContainerComponent } from '../../../common/components/detail-container/detail-container.component';
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { consts } from '../../../common/modals/consts';
import { Subscription } from 'rxjs';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { CompanyAlertSettings } from '../../../message-models/company-alert-settings.class';
import { ICompanyAlertSettings } from '../../../message-models/company-alert-settings.interface';
import { CompanyAlertEmailSettings } from '../../../message-models/company-alert-email-settings.class';
import { ICompanyAlertEmailSettings } from '../../../message-models/company-alert-email-settings.interface';
import { CompanyService } from '../../../company/services/company.service';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { EcaConfirmDeleteModalOptions } from '../../../shared/models/confirm-delete-modal-options.class';
import { CompanySettingsModalService } from '../../../company/services/company-settings-modal.service';

@Component({
  selector: 'app-company-alerts-settings',
  templateUrl: './company-alerts-settings.component.html',
  styleUrls: ['./company-alerts-settings.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CompanyAlertsSettingsComponent implements OnInit {
  @ViewChild('alertSettingsContainerComponent') alertSettingsContainerComponent: DetailContainerComponent;
  editingDetails: boolean;
  public loggedInUser: IUserInfo;
  public companyId: string = consts.emptyGuid;
  loggedInUserSubscription: Subscription;
  isAlertSettingsLoading: boolean = false;
  tempCompanyAlertSetting: CompanyAlertSettings = new CompanyAlertSettings();
  AlertSetting: CompanyAlertSettings = new CompanyAlertSettings();
  companyAlertSettings: CompanyAlertSettings = new CompanyAlertSettings({} as ICompanyAlertSettings);
  tempCompanyAlertEmailSetting: Array<ICompanyAlertEmailSettings> = new Array<ICompanyAlertEmailSettings>();
  companyAlertEmailSettings: Array<CompanyAlertEmailSettings> = new Array<CompanyAlertEmailSettings>({} as ICompanyAlertEmailSettings);
  saveAttempted: boolean = false;

  // originalTrainingRecord: TrainingRecord = new TrainingRecord({} as ITrainingRecord);
  constructor(private route: ActivatedRoute,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private userService: OurUserService,
    private errorHandlingService: ErrorHandlingService,
    private companyService: CompanyService,
    private confirmProcessService: EcaConfirmProcessService,
    private companySettingsModalService: CompanySettingsModalService) {
  }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.updateUserAndReload(user);
        this.populateBreadcrumbs();
        this.companyId = this.loggedInUser?.companyId;
        this.isAlertSettingsLoading = true;
        this.getFrequency();
        this.getAlertEmails();
        this.isAlertSettingsLoading = false;
      })
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
  }

  ngOnDestroy() {
    this.loggedInUserSubscription.unsubscribe();
    }

  private updateUserAndReload(user: IUserInfo) {
    this.loggedInUser = user;
    this.companyId = this.loggedInUser?.companyId;
    if (this.companyId !== consts.emptyGuid && this.companyId !== undefined) {
    }
    this.populateBreadcrumbs();
  }

  private populateBreadcrumbs() {
    const companySettingsBreadCrumbs = new Array<IBreadcrumb>();
    companySettingsBreadCrumbs.push({ label: 'Company Settings', iconName: 'users', routeLink: '/company-settings' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(companySettingsBreadCrumbs);
  }

  getFrequency() {
    this.tempCompanyAlertSetting.companyId = this.companyId;
    this.companyService.getCompanyAlertFrequencySettings(new CompanyAlertSettings(this.tempCompanyAlertSetting)).subscribe(companyAlertSetting => {
      this.companyAlertSettings = new CompanyAlertSettings(companyAlertSetting);
      this.tempCompanyAlertSetting = new CompanyAlertSettings(this.companyAlertSettings);
    }, (error) => {
      console.log(error);
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
  }

  getAlertEmails() {
    this.AlertSetting.companyId = this.companyId;
    this.companyService.getCompanyAlertEmailSettings(new CompanyAlertSettings(this.AlertSetting)).subscribe(companyAlertEmailSetting => {
      this.tempCompanyAlertEmailSetting = companyAlertEmailSetting;
    }, (error) => {
      console.log(error);
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
  }

  editDetails() {
    this.editingDetails = true;
  }

  cancelEdit() {
    this.tempCompanyAlertSetting = new CompanyAlertSettings(this.companyAlertSettings as ICompanyAlertSettings);
    this.editingDetails = false;
  }

  saveDetails() {
    this.isAlertSettingsLoading = true;
    this.tempCompanyAlertSetting.companyId = this.companyId;
    this.companyService.createOrUpdateCompanyAlertSettings(new CompanyAlertSettings(this.tempCompanyAlertSetting)).subscribe(companyAlertSetting => {
      this.companyAlertSettings = new CompanyAlertSettings(companyAlertSetting);
      this.tempCompanyAlertSetting = new CompanyAlertSettings(this.companyAlertSettings as ICompanyAlertSettings);
      this.editingDetails = false;
      this.isAlertSettingsLoading = false;
      this.getFrequency();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  addRecipientEmailClick() {
    this.companySettingsModalService.openCompanySettingsEmailModal('Add Recipient Email')
      .subscribe(companySettingsModalRef => {
        companySettingsModalRef.content.modalClosed.subscribe(result => {
          this.modalClosed();
        })
      });
  }

  removeEmailClick(companySettings: CompanyAlertEmailSettings) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to stop this user from receiving alerts?',
      'Remove ' + companySettings.personName + ' - ' + companySettings.email, new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.isAlertSettingsLoading = true;
            this.removeEmail(companySettings);
          }
        }
      });
  }

  removeEmail(companySettings: CompanyAlertEmailSettings) {
    this.companyService.removeEmail(companySettings).subscribe(result => {
      this.getAlertEmails();
      this.isAlertSettingsLoading = false;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  modalClosed() {
    this.isAlertSettingsLoading = true;
    this.getAlertEmails();
    this.isAlertSettingsLoading = false;
  }
}
